 <div id="loader"
  [ngStyle]="{
    'background': 'rgba(255,255,255,.8) url(' + loaderGifUrl + ') 50% 50% no-repeat',
    'background-size': '20%'
  }">
</div>